<template>
  <div>
    <v-card
      v-model="showModal"
      class="my-card-style"
    >
      <v-container fluid>
        <v-radio-group
          v-model="week"
          row
        >
          <v-radio
            label="Daily"
            value="daily"
          />
          <v-spacer />
          <v-radio
            label="Weekdays"
            value="weekdays"
          />
          <v-spacer />
          <v-radio
            label="Weekends"
            value="weekends"
          />
        </v-radio-group>
        <hr>
        <v-row>
          <v-col sm="2">
            <v-checkbox
              v-model="days.mon"
              label="Monday"
              color="#FF3700"
            />
          </v-col>
          <v-col sm="2">
            <v-checkbox
              v-model="days.tue"
              label="Tuesday"
              color="#FF3700"
            />
          </v-col>
          <v-col sm="2">
            <v-checkbox
              v-model="days.wed"
              label="Wednesday"
              color="#FF3700"
            />
          </v-col>
          <v-col sm="2">
            <v-checkbox
              v-model="days.thu"
              label="Thursday"
              color="#FF3700"
            />
          </v-col>
          <v-col sm="2">
            <v-checkbox
              v-model="days.fri"
              label="Friday"
              color="#FF3700"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="2">
            <v-checkbox
              v-model="days.sat"
              label="Saturday"
              color="#FF3700"
            />
          </v-col>
          <v-col sm="2">
            <v-checkbox
              v-model="days.sun"
              label="Sunday"
              color="#FF3700"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-dialog
              ref="startDialog"
              v-model="startClock"
              :return-value.sync="start"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="start"
                  label="Start Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="startClock"
                v-model="start"
                color="#37474F"
                full-width
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="startClock = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.startDialog.save(start)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-dialog
              ref="endDialog"
              v-model="endClock"
              :return-value.sync="end"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="end"
                  label="End Time"
                  prepend-icon="mdi-clock-time-four-outline"
                  v-bind="attrs"
                  v-on="on"
                />
              </template>
              <v-time-picker
                v-if="endClock"
                v-model="end"
                color="#37474F"
                :min="start"
                full-width
              >
                <v-spacer />
                <v-btn
                  text
                  color="primary"
                  @click="endClock = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.endDialog.save(end)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-btn
            class="ma-2"
            color="red darken-3"
            depressed
            default
            rounded
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer />
          <v-btn
            class="ma-2"
            color="#FF3700"
            depressed
            default
            rounded
            :disabled="!disableSave"
            @click="submit()"
          >
            Update
          </v-btn>
        </v-row>
      </v-container>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </div>
</template>
<script>
import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    components: {
      'centre-spinner': spinner,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      editvalues: {
        type: Object,
        required: true,
      },
      scheduleindex: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        start: '',
        end: '',
        startClock: false,
        endClock: false,
        week: false,
        days: {
          sun: false,
          mon: false,
          tue: false,
          wed: false,
          thu: false,
          fri: false,
          sat: false,
        },
        showModal: true,
        loading: false,
      };
    },
    computed: {
      disableSave () {
        return Object.values(this.days).some(val => val === true) && this.start && this.end;
      },
    },
    watch: {
      week: function (newval) {
        if (newval === 'weekends') {
          this.days.sun = true;
          this.days.mon = false;
          this.days.tue = false;
          this.days.wed = false;
          this.days.thu = false;
          this.days.fri = false;
          this.days.sat = true;
        }
        if (newval === 'weekdays') {
          this.days.sun = false;
          this.days.mon = true;
          this.days.tue = true;
          this.days.wed = true;
          this.days.thu = true;
          this.days.fri = true;
          this.days.sat = false;
        }
        if (newval === 'daily') {
          this.days.sun = true;
          this.days.mon = true;
          this.days.tue = true;
          this.days.wed = true;
          this.days.thu = true;
          this.days.fri = true;
          this.days.sat = true;
        }
      },
       showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.start = this.editvalues.start;
      this.end = this.editvalues.end;
      if (this.editvalues.active_days.includes('sun')) {
        this.days.sun = true;
      }
      if (this.editvalues.active_days.includes('mon')) {
        this.days.mon = true;
      }
      if (this.editvalues.active_days.includes('tue')) {
        this.days.tue = true;
      }
      if (this.editvalues.active_days.includes('wed')) {
        this.days.wed = true;
      }
      if (this.editvalues.active_days.includes('thu')) {
        this.days.thu = true;
      }
      if (this.editvalues.active_days.includes('fri')) {
        this.days.fri = true;
      }
      if (this.editvalues.active_days.includes('sat')) {
        this.days.sat = true;
      }
    },
    methods: {
      async submit () {
       this.loading = true;
       await this.$store.dispatch('schedule/deleteAdvancedScheduleData', this.scheduleindex);
       this.$store.dispatch('schedule/fetchAdvancedScheduleData', {
          days: {
            sun: this.days.sun,
            mon: this.days.mon,
            tue: this.days.tue,
            wed: this.days.wed,
            thu: this.days.thu,
            fri: this.days.fri,
            sat: this.days.sat,
          },
          start: this.start,
          end: this.end,
          id: this.editvalues.id,
        }).then(response => {
          this.close();
          this.loading = false;
        }).catch(() => {
          this.loading = false;
          this.close();
        });
      },
      close () {
        this.showModal = false;
      },
    },
  };
</script>
<style scoped>
.my-card-style {
  border-radius: 25px;
}
</style>
